import { createHelpers } from 'vuex-map-fields';


export const mapFieldsMetadata= createHelpers({
    getterType: 'documents/getMetadataField',
    mutationType: 'documents/updateMetadataField',
  }).mapFields;
  
export const vuexPrefix=(prefix, fields, path)=>{
    var result={}
    fields.forEach(x=>result[prefix+x]=path+x)
    return result
}

export const vuexPrefix2 = (prefix, fields, path, append_to_path) => {
  var result = {};
  append_to_path.forEach(x => { 
    fields.forEach(y => {
      result[prefix + x + '_' + y] = path + x + '.' + y
    });
  });
  return result;
}